import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';

import { getAlbumFolderHierarchyString } from '../../util/album-folder';
import Button from '../global/Button';
import CustomControl from '../global/CustomControl';
import withModal from '../global/modal/withModal';
import { DISCOVER_IDENTITY_SELECTED_ALBUMS } from '../../constants/modals';
import IdentityAvatarContainer from '../../containers/global/identity/IdentityAvatarContainer';
import { AVATAR_SIZE_36 } from '../../constants/avatar-sizes';
import { isPrimaryIdentity } from '../../util/identity';
import ContextualString from '../contextual/ContextualString';

const propTypes = {
  identity: PropTypes.shape({
    selectedAlbums: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.name,
        albumFolderHierarchy: PropTypes.arrayOf(
          PropTypes.shape({
            name: PropTypes.string,
          }),
        ),
      }),
    ).isRequired,
  }).isRequired,
  onDeselectAlbum: PropTypes.func.isRequired,
  albumFolder: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  onRequestClose: PropTypes.func,
};

const DiscoverAlbumFolderAlbumSelectionModal = ({
  identity,
  onDeselectAlbum,
  albumFolder,
  onRequestClose,
}) => {
  useEffect(() => {
    if (identity.selectedAlbums.length === 0) {
      onRequestClose();
    }
  }, [identity]);

  return (
    <Fragment>
      <div className="mb-1">
        <h3 className="text-center mb-0">
          Selected{' '}
          <ContextualString
            id="consumerAlbum"
            subtype={albumFolder.album_subtype}
            defaultMessage="albums"
            formatter={string => pluralize(string, 2)}
          />{' '}
          for
          <IdentityAvatarContainer
            size={AVATAR_SIZE_36}
            identity={identity}
            className="ml-1 mb-1"
          />
          <span className="text-dark ml-1">
            {isPrimaryIdentity(identity) ? 'you' : identity.name}
          </span>
        </h3>
      </div>
      <div className="discover-album-folder-list-container">
        {identity.selectedAlbums.map(selectedAlbum => (
          <div
            className="discover-album-folder-container"
            key={selectedAlbum.id}
          >
            <Button
              btnStyle="reset"
              className="d-flex align-items-center w-100"
              onClick={() => onDeselectAlbum(selectedAlbum, identity.id)}
            >
              <div className="d-flex flex-column mr-2">
                <span className="text-dark text-extra-bold">
                  {selectedAlbum.name}
                </span>
                <span className="text-xs text-bold text-faded">
                  {getAlbumFolderHierarchyString(
                    selectedAlbum.albumFolderHierarchy,
                  )}
                </span>
              </div>

              <CustomControl
                id={`selection-${selectedAlbum.id}`}
                label="Selected Album"
                labelSrOnly
                type="checkbox"
                checked
                readOnly
                className="ml-auto mr-0"
              />
            </Button>
          </div>
        ))}
      </div>
    </Fragment>
  );
};

DiscoverAlbumFolderAlbumSelectionModal.propTypes = propTypes;

export default withModal(DiscoverAlbumFolderAlbumSelectionModal, {
  name: DISCOVER_IDENTITY_SELECTED_ALBUMS,
  size: 'sm',
  dismissible: true,
});
